import { Component, OnInit, forwardRef, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyService } from '../../_services/company.service';

@Component({
  selector: 'app-company-autocomplete',
  templateUrl: './company-autocomplete.component.html',
  styleUrls: ['./company-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyAutocompleteComponent),
      multi: true
    }
  ]
})
export class CompanyAutocompleteComponent implements ControlValueAccessor {
  @Input() placeholder: string = "N'importe quelle Société";
  @Input() value;
  @Input() allowAdd: boolean = false;
  @Input() is_seller: boolean;
  @Output() notFound: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueSelected: EventEmitter<string> = new EventEmitter<string>();
  propagateChange = (_: any) => { };

  private companies: object[];
  private selected: object;
  private showResults: boolean = false;
  private noResults: boolean = false;


  constructor(private service: CompanyService, private elRef: ElementRef) {}

  writeValue(value: any): void {
    if (value !== undefined && value !== "" && value !== null) {
      // If an Object is given, just take the ID as value
      if (value instanceof Object) {
        this.value = value.name;
        this.selected = value;
        this.elRef.nativeElement.querySelector('.company').value = value.name;
      } else { // Is Not an Empty String
        this.service.getCompany(value).subscribe(response => {
          if (response) {
            this.selected = response;
            this.elRef.nativeElement.querySelector('.company').value = response.name;
            this.value = response.name;
          } else {
            this.selected = undefined;
            this.elRef.nativeElement.querySelector('.company').value = null;
            this.value = "";
          }

        });
      }
    } else {
      this.value = "";
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeValue(value) {
    this.propagateChange(value);
  }

  search(value) {

    this.service.autocompleteCompanies(value || '', this.is_seller).subscribe(response => {
      this.companies = response;
      this.noResults = !this.companies.length;
    });
  }

  ngOnInit() {
    this.changeValue(this.elRef.nativeElement.querySelector('.company').value);
  }

  selectResult(company) {
    if (company) {
      this.elRef.nativeElement.querySelector('.company').value = company.name;
      this.changeValue(company.id);
      this.valueSelected.emit(company);
    }
  }

  onFocus() {
    this.search('');
    this.showResults = true;
  }

  onBlur(event) {
    if (this.noResults) this.triggerAdd(event.target.value)
    setTimeout(function () {
      this.showResults = false;
    }.bind(this), 200);
  }

  triggerAdd(companyName) {
    this.notFound.emit(companyName);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company-autocomplete/company-autocomplete.component.ts